import { FC } from "react";
import classes from './transactionItem.module.scss'
import { ITransactionsAdmin } from "../../model/types";
import { Link } from "react-router-dom";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { TransactionMetaPopover } from "../../../../shared/ui/transactionMeta/TransactionMetaPopover";

interface IProps {
    transaction: ITransactionsAdmin;
}

export const AdminTransactionItem: FC<IProps> = ({transaction}) => {

    return (
        <tr 
            className={classes.item}
        >
            <td>
                {formatUtcToMsk(transaction.created_at)} (мск)
            </td>  
            <td>
                {transaction.amount}
            </td>
            <td>
                {transaction.is_confirmed ? <>&#9989;</> : <>&#10060;</>}
            </td>
            <td>
                {transaction.is_manual ? <>&#9989;</> : <>&#10060;</>}
            </td>
            <td>
                <Link to={'/students/' + transaction.student_id}>{transaction.student_name}</Link>
            </td>  
            <td>
                <TransactionMetaPopover meta={transaction.meta} />
            </td>
        </tr>
       )
}
